export default [
  {
    name: 'orders',
    path: 'orders',
    component: () => import('../views/orders'),
    children: [
      {
        name: 'orders-list',
        path: 'list',
        component: () => import('../views/orders/List'),
      },
      {
        name: 'orders-single',
        path: ':id',
        component: () => import('../views/orders/Single'),
      },
    ],
  },
  {
    name: 'users',
    path: 'users',
    component: () => import('../views/users'),
    children: [
      {
        name: 'users-list',
        path: 'list',
        component: () => import('../views/users/components/UsersList.vue'),
      },
      {
        name: 'users-deleted',
        path: 'deleted',
        component: () => import('../views/users/components/UsersDeleted.vue'),
      },
      {
        name: 'user-single',
        path: ':id',
        component: () => import('../views/users/single.vue'),
      },
    ],
  },
  {
    name: 'categories',
    path: 'categories',
    component: () => import('../views/categories'),
  },
  {
    name: 'categoriesSingle',
    path: 'categories/:id',
    component: () => import('../views/categories/single.vue'),
  },
  {
    name: 'notification',
    path: 'notification',
    component: () => import('../views/notification'),
  },
  {
    name: 'reports',
    path: 'reports',
    component: () => import('../views/reports'),
  },
  {
    name: 'publications',
    path: 'publications',
    component: () => import('../views/publications'),
  },
  {
    name: 'publications-single',
    path: 'publications/:id',
    component: () => import('../views/publications/single'),
  },
  {
    name: 'bls',
    path: 'bls',
    component: () => import('../views/bls/'),
  },
  {
    name: 'bls-single',
    path: 'bls/:id',
    component: () => import('../views/bls/singleReport'),
  },
]
